import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import OutlinedInput from "@mui/material/OutlinedInput";
import Slide from "@mui/material/Slide";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import axios from "axios";
import cogoToast from "cogo-toast";
import CryptoJS from "crypto-js";
import * as React from "react";
import { useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { MdAdd } from "react-icons/md";
import QRCode from "react-qr-code";
import { useSelector } from "react-redux";
import {
  FileLoader,
  UploadApi
} from "../constants/Constants";
import {
  AWS_Access_Key_Id_Encypt,
  AWS_Bucket_Name,
  AWS_Region,
  AWS_Secret_Access_Key_Encypt,
} from "../constants/bucketCostant";
import CustomizedSnackbars from "./CustomizedSnackbars";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function MultiFolderShare({
  email,
  cOpen,
  setCOpen,
  cAccession,
}) {
  const secretKey = "your-secret-key"; // Replace with your secret key
  const Fold = "Multi";
  const [isOpen, setIsOpen] = React.useState(false);
  const [pass, setPass] = useState("");
  // const [selectedAvatar, setSelectedAvatar] = useState([]);
  const [folderlist, setFolderlist] = useState([]);
  // const [email, setEmail] = useState("");
  const [show, setshow] = useState(false);
  const [modal, setModal] = useState(false);
  const [date, setDate] = React.useState("");
  const [emailToSend, setEmailToSend] = React.useState("");
  const state = useSelector((state) => state.user);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const fullScreen2 = useMediaQuery(theme.breakpoints.down("lg"));
  const [urlSafeEmail, setUrlSafeEmail] = useState("");
  const [urlSafePass, setUrlSafePass] = useState("");
  const [urlSafeDate, setUrlSafeDate] = useState("");
  const [urlSafeFold, setUrlSafeFold] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const token = localStorage.getItem("token");
  const [selected, setselected] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedFolderNames, setSelectedFolderNames] = useState([]);
  const viewKeyImagesOnly = useSelector((state) => state.isOnlyKeyImages);
  const [nonEditedShareData, setNonEditedShareData] = useState([]);
  const [ObjData, setObjData] = useState([
    {
      email: "",
      pass: "",
      date: "",
      url: "",
      Folders: false,
      selectedFolders: [],
      canUpload: "",
      isKeyImagesOnly: "",
      canShare: "",
    },
  ]);

  const TinyTextSharedFolders = async (full_url) => {
    try {
      const response = await axios.get(
        `${UploadApi}/apiUpload/api-create?url=${encodeURIComponent(full_url)}`
      );

      return response.data;
    } catch (error) {
      return full_url;
    }
  };

  const GetFolderShareList = async () => {
    try {
      let response = await axios.get(
        `${FileLoader}/fileloaderv1/files/GetSharedList?FolderName=${Fold}/&awsAccessKeyId=${encodeURIComponent(
          AWS_Access_Key_Id_Encypt()
        )}&awsSecretAccessKey=${encodeURIComponent(
          AWS_Secret_Access_Key_Encypt()
        )}&awsbucketname=${AWS_Bucket_Name()}&Region=${AWS_Region()}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data) {
        const transformedApiResponse = response.data
          .filter((item) => item.name != null && item.name != "null")
          .map((item, index) => {
            // const parts = item?.url?.split("/");
            const names = item.name;
            // const modifiedFolder = parts[7].replace(/bbbb/g, "/");
            // Extract decrypted email, password, date, and folder from decoded parts
            // const decryptedFolderBytes = CryptoJS?.AES?.decrypt(
            //   modifiedFolder.split("?")[0],
            //   secretKey
            // );
            // console.log(decryptedFolderBytes);
            // const decryptedFolder = decryptedFolderBytes?.toString(
            //   CryptoJS?.enc?.Utf8
            // );
            // let list;
            // if (names.includes(",")) {
            //   list = JSON.parse(names);
            // }
            let list = [];

            if (names.includes(",")) {
              // Remove square brackets and split by comma
              list = names.split(",").map((item) => item.trim());
            } else {
              // Remove square brackets and keep the single name
              list.push(names.trim());
            }

            // let getlist= list?.split(",")
            // Return transformed data
            return {
              email: item.name,
              date: item.expiryDate,
              pass: item.pass,
              url: item.url,
              selectedFolders: list, // Assuming folder is JSON stringified
              createdAt: item.urlcreationDate,
              updatedAt: item.urlupdateDate,
              canUpload: item.canUpload,
              isKeyImagesOnly: item.isKeyImagesOnly,
              canShare: item.canShare,
            };
          });

        setObjData(transformedApiResponse);
        setNonEditedShareData(transformedApiResponse);

        const transformedApiResponseTiny = await Promise.all(
          response.data.map(async (item, index) => {
            const tempUrl = await TinyTextSharedFolders(item.url);
            return tempUrl;
          })
        );
        setCopiedText(transformedApiResponseTiny);
      } else {
        setObjData([
          {
            email: "",
            pass: "",
            date: "",
            url: "",
          },
        ]);
      }
    } catch (error) {}
  };

  const GetFolderList = async () => {
    try {
      const response = await fetch(
        `${FileLoader}/fileloaderv1/files/GetFolderList/?awsAccessKeyId=${encodeURIComponent(
          AWS_Access_Key_Id_Encypt()
        )}&awsSecretAccessKey=${encodeURIComponent(
          AWS_Secret_Access_Key_Encypt()
        )}&bucketName=${AWS_Bucket_Name()}&Region=${AWS_Region()}`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
          headers: {
            Authorization: `Bearer ${token}`, // Replace 'yourAccessToken' with the actual access token
          },
        }
      );
      const GetFolderList = await response.json();
      setFolderlist(GetFolderList);
    } catch (error) {
      console.log(error);
    }
  };

  React.useEffect(() => {
    if (cOpen == true) {
      GetFolderShareList();
    }
  }, [cOpen]);

  React.useEffect(() => {
    if (cOpen == true) {
      GetFolderList();
    }
  }, [cOpen]);

  // let ArrayForRender=[1,1];

  // const onChangeField = (e) => {
  //   setObjData()
  // };

  // const onChangeField = (index, field, value) => {
  //   const updatedObjData = [...ObjData];
  //   updatedObjData[index] = {
  //     ...updatedObjData[index],
  //     [field]: value,
  //   };
  //   setObjData(updatedObjData);
  // };
  // const onChangeField = (event, i) => {
  //   const value = event.target.value;
  //   const name = event.target.name;
  //   const prevData = [...ObjData];  // Create a new array with the same elements

  //   // Create a new object based on the current element at index i and update the property [name] with the new value
  //   prevData[i] = {
  //     ...prevData[i],
  //     [name]: value
  //   };

  //   // Set the updated array as the new state
  //   setObjData(prevData);
  // };

  const onChangeField = (event, i) => {
    const value = event.target.value;
    const name = event.target.name;
    const type = event.target.type;
    const prevData = [...ObjData];

    // Encrypt the updated email, password, and date
    let encryptedEmail = "";
    let encryptedPass = "";
    let encryptedDate = "";
    let encryptedFolder = "";

    const valueUpload = prevData[i].canUpload;
    const valueKeyImages = prevData[i].isKeyImagesOnly;
    const valueShare = prevData[i].canShare;
    let urlSafeValue = "";
    let urlSafeKeyImages = "";
    let urlSafeShare = "";
    if (
      valueUpload == undefined ||
      valueUpload == "" ||
      valueUpload == "notofileupload"
    ) {
      if (name == "canUpload") {
        const encryptedValue = CryptoJS.AES.encrypt(
          "yestofileupload",
          secretKey
        ).toString();
        urlSafeValue = encryptedValue.replace(/\//g, "bbbb");
      } else {
        const encryptedValue = CryptoJS.AES.encrypt(
          "notofileupload",
          secretKey
        ).toString();
        urlSafeValue = encryptedValue.replace(/\//g, "bbbb");
      }
    } else {
      if (name == "canUpload") {
        const encryptedValue = CryptoJS.AES.encrypt(
          "notofileupload",
          secretKey
        ).toString();
        urlSafeValue = encryptedValue.replace(/\//g, "bbbb");
      } else {
        const encryptedValue = CryptoJS.AES.encrypt(
          "yestofileupload",
          secretKey
        ).toString();
        urlSafeValue = encryptedValue.replace(/\//g, "bbbb");
      }
    }

    if (
      valueKeyImages == undefined ||
      valueKeyImages == "" ||
      valueKeyImages == "allimages"
    ) {
      if (name == "onlyKeyImages") {
        const encryptedImages = CryptoJS.AES.encrypt(
          "onlykeyimages",
          secretKey
        ).toString();
        urlSafeKeyImages = encryptedImages.replace(/\//g, "bbbb");

        const encryptedValue = CryptoJS.AES.encrypt(
          "notofileupload",
          secretKey
        ).toString();
        urlSafeValue = encryptedValue.replace(/\//g, "bbbb");
      } else {
        const encryptedImages = CryptoJS.AES.encrypt(
          "allimages",
          secretKey
        ).toString();
        urlSafeKeyImages = encryptedImages.replace(/\//g, "bbbb");
      }
    } else {
      if (name == "onlyKeyImages") {
        const encryptedImages = CryptoJS.AES.encrypt(
          "allimages",
          secretKey
        ).toString();
        urlSafeKeyImages = encryptedImages.replace(/\//g, "bbbb");
      } else {
        const encryptedImages = CryptoJS.AES.encrypt(
          "onlykeyimages",
          secretKey
        ).toString();
        urlSafeKeyImages = encryptedImages.replace(/\//g, "bbbb");

        const encryptedValue = CryptoJS.AES.encrypt(
          "notofileupload",
          secretKey
        ).toString();
        urlSafeValue = encryptedValue.replace(/\//g, "bbbb");
      }
    }

    if (
      valueShare == undefined ||
      valueShare == "" ||
      valueShare == "noshare"
    ) {
      if (name == "canShare") {
        const encryptedShares = CryptoJS.AES.encrypt(
          "yesshare",
          secretKey
        ).toString();
        urlSafeShare = encryptedShares.replace(/\//g, "bbbb");
      } else {
        const encryptedShares = CryptoJS.AES.encrypt(
          "noshare",
          secretKey
        ).toString();
        urlSafeShare = encryptedShares.replace(/\//g, "bbbb");
      }
    } else {
      if (name == "canShare") {
        const encryptedShares = CryptoJS.AES.encrypt(
          "noshare",
          secretKey
        ).toString();
        urlSafeShare = encryptedShares.replace(/\//g, "bbbb");
      } else {
        const encryptedShares = CryptoJS.AES.encrypt(
          "yesshare",
          secretKey
        ).toString();
        urlSafeShare = encryptedShares.replace(/\//g, "bbbb");
      }
    }

    if (type == "email") {
      // encryptedFolder = CryptoJS.AES.encrypt(Fold, secretKey).toString();
      // let urlSafefold = encryptedFolder.replace(/\//g, "bbbb");
      // setUrlSafeFold(urlSafefold);

      encryptedEmail = CryptoJS.AES.encrypt(value, secretKey).toString();
      let urlSafeEmail = encryptedEmail.replace(/\//g, "bbbb");
      setUrlSafeEmail(urlSafeEmail);
      prevData[i] = {
        ...prevData[i],
        [name]: value,
        url: `${
          window.origin
        }/signin/${urlSafeFold}/${urlSafePass}/${urlSafeDate}/${urlSafeFold}?de=${encodeURIComponent(
          urlSafeValue
        )}&key=${encodeURIComponent(
          urlSafeKeyImages
        )}&sharing=${encodeURIComponent(urlSafeShare)}`,
      };
    }
    if (type == "password" || type == "text") {
      // encryptedFolder = CryptoJS.AES.encrypt(Fold, secretKey).toString();
      // let urlSafefold = encryptedFolder.replace(/\//g, "bbbb");
      // setUrlSafeFold(urlSafefold);

      encryptedDate = CryptoJS.AES.encrypt(
        prevData[i].date,
        secretKey
      ).toString();
      let urlSafeDateIfEmpty = encryptedDate.replace(/\//g, "bbbb");

      encryptedPass = CryptoJS.AES.encrypt(value, secretKey).toString();
      let urlSafePass = encryptedPass.replace(/\//g, "bbbb");
      setUrlSafePass(urlSafePass);
      prevData[i] = {
        ...prevData[i],
        [name]: value,
        url: `${window.origin}/signin/${urlSafeFold}/${urlSafePass}/${
          urlSafeDate === "" ? urlSafeDateIfEmpty : urlSafeDate
        }/${urlSafeFold}?de=${encodeURIComponent(
          urlSafeValue
        )}&key=${encodeURIComponent(
          urlSafeKeyImages
        )}&sharing=${encodeURIComponent(urlSafeShare)}`,
      };
    }
    if (type == "date") {
      // encryptedFolder = CryptoJS.AES.encrypt(Fold, secretKey).toString();
      // let urlSafefold = encryptedFolder.replace(/\//g, "bbbb");
      // setUrlSafeFold(urlSafefold);

      encryptedPass = CryptoJS.AES.encrypt(
        prevData[i].pass,
        secretKey
      ).toString();
      let urlSafePassIfEmpty = encryptedPass.replace(/\//g, "bbbb");

      encryptedDate = CryptoJS.AES.encrypt(value, secretKey).toString();
      let urlSafeDate = encryptedDate.replace(/\//g, "bbbb");
      setUrlSafeDate(urlSafeDate);
      prevData[i] = {
        ...prevData[i],
        [name]: value,
        url: `${window.origin}/signin/${urlSafeFold}/${
          urlSafePass === "" ? urlSafePassIfEmpty : urlSafePass
        }/${urlSafeDate}/${urlSafeFold}?de=${encodeURIComponent(
          urlSafeValue
        )}&key=${encodeURIComponent(
          urlSafeKeyImages
        )}&sharing=${encodeURIComponent(urlSafeShare)}`,
      };
    }

    if (name == "canUpload") {
      encryptedDate = CryptoJS.AES.encrypt(
        prevData[i].date,
        secretKey
      ).toString();
      let urlSafeDateIfEmpty = encryptedDate.replace(/\//g, "bbbb");

      encryptedPass = CryptoJS.AES.encrypt(
        prevData[i].pass,
        secretKey
      ).toString();
      let urlSafePassIfEmpty = encryptedPass.replace(/\//g, "bbbb");

      prevData[i] = {
        ...prevData[i],
        ["canUpload"]:
          valueUpload === "yestofileupload"
            ? "notofileupload"
            : "yestofileupload",
        url: `${window.origin}/signin/${urlSafeFold}/${
          urlSafePass === "" ? urlSafePassIfEmpty : urlSafePass
        }/${
          urlSafeDate === "" ? urlSafeDateIfEmpty : urlSafeDate
        }/${urlSafeFold}?de=${encodeURIComponent(
          urlSafeValue
        )}&key=${encodeURIComponent(
          urlSafeKeyImages
        )}&sharing=${encodeURIComponent(urlSafeShare)}`,
      };
    }

    if (name == "onlyKeyImages") {
      encryptedDate = CryptoJS.AES.encrypt(
        prevData[i].date,
        secretKey
      ).toString();
      let urlSafeDateIfEmpty = encryptedDate.replace(/\//g, "bbbb");

      encryptedPass = CryptoJS.AES.encrypt(
        prevData[i].pass,
        secretKey
      ).toString();
      let urlSafePassIfEmpty = encryptedPass.replace(/\//g, "bbbb");

      prevData[i] = {
        ...prevData[i],
        ["isKeyImagesOnly"]:
          valueKeyImages === "onlykeyimages" ? "allimages" : "onlykeyimages",
        ["canUpload"]:
          valueKeyImages === "onlykeyimages"
            ? "notofileupload"
            : prevData[i].canUpload,
        url: `${window.origin}/signin/${urlSafeFold}/${
          urlSafePass === "" ? urlSafePassIfEmpty : urlSafePass
        }/${
          urlSafeDate === "" ? urlSafeDateIfEmpty : urlSafeDate
        }/${urlSafeFold}?de=${encodeURIComponent(
          urlSafeValue
        )}&key=${encodeURIComponent(
          urlSafeKeyImages
        )}&sharing=${encodeURIComponent(urlSafeShare)}`,
      };
    }

    if (name == "canShare") {
      encryptedPass = CryptoJS.AES.encrypt(
        prevData[i].pass,
        secretKey
      ).toString();
      let urlSafePassIfEmpty = encryptedPass.replace(/\//g, "bbbb");

      encryptedDate = CryptoJS.AES.encrypt(
        prevData[i].date,
        secretKey
      ).toString();
      let urlSafeDateIfEmpty = encryptedDate.replace(/\//g, "bbbb");

      prevData[i] = {
        ...prevData[i],
        ["canShare"]: valueShare === "yesshare" ? "noshare" : "yesshare",
        url: `${window.origin}/signin/${urlSafeFold}/${
          urlSafePass === "" ? urlSafePassIfEmpty : urlSafePass
        }/${
          urlSafeDate === "" ? urlSafeDateIfEmpty : urlSafeDate
        }/${urlSafeFold}?de=${encodeURIComponent(
          urlSafeValue
        )}&key=${encodeURIComponent(
          urlSafeKeyImages
        )}&sharing=${encodeURIComponent(urlSafeShare)}`,
      };
    }

    if (viewKeyImagesOnly) {
      const encryptedImages = CryptoJS.AES.encrypt(
        "onlykeyimages",
        secretKey
      ).toString();
      urlSafeKeyImages = encryptedImages.replace(/\//g, "bbbb");
    }

    // Update the URL-safe variables

    // Update the specific field with the new value

    // Set the updated array and URL-safe variables as the new state

    setTinyCopiedText(prevData[i], prevData[i]?.url, i);
    setObjData(prevData);
  };

  const SendEmail = async () => {
    try {
      let fromdata = new FormData();

      let newselectedurl = "";
      try {
        const response = await axios.get(
          `${UploadApi}/apiUpload/api-create?url=${encodeURIComponent(
            selected?.url
          )}`
        );

        if (response.data) {
          newselectedurl = response.data;
        } else {
          newselectedurl = selected?.url;
        }
      } catch (error) {
        newselectedurl = selected?.url;
      }

      fromdata.append("address", emailToSend);
      fromdata.append("subject", " Sharing Study");
      fromdata.append(
        "link",
        `${newselectedurl}\n` + `\nPassword:${selected?.pass}`
      );
      fromdata.append("userID", `${selected?.email}`);
      fromdata.append("userPass", `${selected?.pass}`);
      const axiosInstance = axios.create({
        baseURL: `${UploadApi}/user/`,
      });
      axiosInstance
        .post("sendEmailLink", fromdata, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        })
        .then(async (response) => {
          ShareFolderLink(selected, selectedIndex);
          cogoToast.success("Mail send Successfully.", {
            position: "top-right",
          });
          setModal(false);
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  };

  const ShareFolderLink = async (e, i) => {
    let formData = new FormData();
    formData.append("awsAccessKeyId", AWS_Access_Key_Id_Encypt());
    formData.append("awsSecretAccessKey", AWS_Secret_Access_Key_Encypt());

    formData.append(`AccountDetail[0].Name`, e?.selectedFolders);
    formData.append(`AccountDetail[0].expiryDate`, e?.date);
    formData.append(`AccountDetail[0].password`, e?.pass);
    formData.append(`AccountDetail[0].url`, e?.url);
    formData.append(`AccountDetail[0].canUpload`, e?.canUpload);
    formData.append(`AccountDetail[0].isKeyImagesOnly`, e?.isKeyImagesOnly);
    formData.append(`AccountDetail[0].canShare`, e?.canShare);
    formData.append(`AccountDetail[0].urlCreationDate`, e?.createdAt);
    if (nonEditedShareData.length > 0) {
      if (
        e?.createdAt != null &&
        e?.createdAt != undefined &&
        nonEditedShareData[i]?.createdAt != null &&
        nonEditedShareData[i]?.createdAt != undefined &&
        e.createdAt === nonEditedShareData[i].createdAt
      ) {
        formData.append(`AccountDetail[0].urlUpdateDate`, "yes");
      }
    }

    formData.append("awsbucketname", AWS_Bucket_Name());
    formData.append("Region", AWS_Region());
    let requestBody;

    // ObjData?.map(async (item, i) => {
    //   requestBody = {
    //     args: [Fold, state.email, item?.email],
    //     email: state.email,
    //     orgName: "mrc",
    //     fcn: "shareDicomFolder",
    //   };
    //   try {
    //     const response = await axios.post(
    //       `${BlockChain}/api/share-dicom`,
    //       requestBody,
    //       {
    //         headers: {
    //           "Content-Type": "application/json",
    //           Authorization: `Bearer ${token}`,
    //         },
    //       }
    //     );
    //   } catch (error) {
    //     console.error(error);
    //   }
    // });

    try {
      let response = await axios.post(
        `${FileLoader}/fileloaderv1/files/ShareFolder?FolderName=${Fold}/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data && nonEditedShareData.length > 0) {
        if (
          e?.createdAt != null &&
          e?.createdAt != undefined &&
          nonEditedShareData[i]?.createdAt != null &&
          nonEditedShareData[i]?.createdAt != undefined &&
          e.createdAt === nonEditedShareData[i].createdAt
        ) {
          await RemoveSharePerson(nonEditedShareData[i], i);
        }
      }
      GetFolderShareList();
    } catch (error) {
      //console.log(error);
    }
  };

  const saveCredentials = (args) => {
    var data = [];
    if (!localStorage.getItem("dcmCredentails")) {
      data.push(args);
      localStorage.setItem("dcmCredentails", JSON.stringify(data));
    } else {
      data = JSON.parse(localStorage.getItem("dcmCredentails"));
      var filteredData = data.filter((e) => {
        if (e.accession !== args.accession) {
          return e;
        }
      });
      filteredData.push(args);
      localStorage.setItem("dcmCredentails", JSON.stringify(filteredData));
    }
  };

  const ShareData = () => {};

  const AddSharePerson = () => {
    const newObj = {
      email: "",
      pass: "",
      date: "",
    };
    setObjData([...ObjData, newObj]);
  };

  const RemoveSharePerson = async (e, i) => {
    // let formData = new FormData();
    // formData.append(
    //   "awsAccessKeyId",
    //   AWS_Access_Key_Id_Encypt()
    // );
    // formData.append(
    //   "awsSecretAccessKey",
    //   AWS_Secret_Access_Key_Encypt()
    // );
    // formData.append("awsbucketname", process.env.React_App_AWS_Bucket_Name_encypt);

    try {
      let response = await axios.delete(
        // `${DRCoreApi}fileloaderv1/files/DeleteUserByName?FolderName=${Fold}/&name=${e?.email}/`,
        `${FileLoader}/fileloaderv1/files/DeleteUserByName?FolderName=${Fold}/&name=${
          e?.email
        }&awsAccessKeyId=${AWS_Access_Key_Id_Encypt()}&awsSecretAccessKey=${AWS_Secret_Access_Key_Encypt()}&awsbucketname=${AWS_Bucket_Name()}&Region=${AWS_Region()}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {}
    const newArrayForRender = [...ObjData]; // Create a copy of the array
    newArrayForRender.splice(i, 1); // Remove one element at the specified index

    setObjData(newArrayForRender);
    // GetFolderShareList();
  };

  const encodeBase64UrlSafe = (input) => {
    return btoa(input)
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  };

  const encryptedEmail = CryptoJS.AES.encrypt(email, secretKey).toString();
  const encryptedPass = CryptoJS.AES.encrypt(pass, secretKey).toString();
  const encryptedDate = CryptoJS.AES.encrypt(date, secretKey).toString();

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedFolders, setSelectedFolders] = useState([]);

  const toggleDropdown = (i) => {
    const prevData = [...ObjData];
    if (prevData[i]) {
      // Assuming 'keyToUpdate' is the key you want to update
      prevData[i].Folders = !prevData[i].Folders; // Replace 'newValue' with the value you want to assign
    }
    setObjData(prevData);
  };

  const handleCheckboxChange = (event, i) => {
    const folderName = event.target.value;
    const prevData = [...ObjData];
    const selectedFolder = [...(prevData[i]?.selectedFolders || [])];

    const valueUpload = prevData[i].canUpload;
    const valueKeyImages = prevData[i].isKeyImagesOnly;
    const valueShare = prevData[i].canShare;
    let urlSafeValue = "";
    let urlSafeKeyImages = "";
    let urlSafeShare = "";
    if (
      valueUpload == undefined ||
      valueUpload == "" ||
      valueUpload == "notofileupload"
    ) {
      const encryptedValue = CryptoJS.AES.encrypt(
        "yestofileupload",
        secretKey
      ).toString();
      urlSafeValue = encryptedValue.replace(/\//g, "bbbb");
    } else {
      const encryptedValue = CryptoJS.AES.encrypt(
        "notofileupload",
        secretKey
      ).toString();
      urlSafeValue = encryptedValue.replace(/\//g, "bbbb");
    }

    if (
      valueKeyImages == undefined ||
      valueKeyImages == "" ||
      valueKeyImages == "allimages"
    ) {
      const encryptedImages = CryptoJS.AES.encrypt(
        "onlykeyimages",
        secretKey
      ).toString();
      urlSafeKeyImages = encryptedImages.replace(/\//g, "bbbb");
    } else {
      const encryptedImages = CryptoJS.AES.encrypt(
        "allimages",
        secretKey
      ).toString();
      urlSafeKeyImages = encryptedImages.replace(/\//g, "bbbb");
    }

    if (
      valueShare == undefined ||
      valueShare == "" ||
      valueShare == "noshare"
    ) {
      const encryptedSharing = CryptoJS.AES.encrypt(
        "yesshare",
        secretKey
      ).toString();
      urlSafeShare = encryptedSharing.replace(/\//g, "bbbb");
    } else {
      const encryptedSharing = CryptoJS.AES.encrypt(
        "noshare",
        secretKey
      ).toString();
      urlSafeShare = encryptedSharing.replace(/\//g, "bbbb");
    }

    if (event.target.checked) {
      setSelectedFolders([...selectedFolders, folderName]);
      setSelectedFolderNames([...selectedFolderNames, folderName]);
      let jsonString = JSON.stringify([...selectedFolder, folderName]);
      let encryptedData = CryptoJS.AES.encrypt(
        jsonString,
        secretKey
      ).toString();
      let urlSafefold = encryptedData.replace(/\//g, "bbbb");
      setUrlSafeFold(urlSafefold);

      prevData[i] = {
        ...prevData[i],
        url: `${
          window.origin
        }/signin/${urlSafefold}/${urlSafePass}/${urlSafeDate}/${urlSafefold}?de=${encodeURIComponent(
          urlSafeValue
        )}&key=${encodeURIComponent(
          urlSafeKeyImages
        )}&sharing=${encodeURIComponent(urlSafeShare)}`,
        selectedFolders: [...selectedFolder, folderName],
      };
    } else {
      setSelectedFolders(
        selectedFolders.filter((folder) => folder !== folderName)
      );
      setSelectedFolderNames(
        selectedFolderNames.filter((name) => name !== folderName)
      );
      let jsonString = JSON.stringify(
        selectedFolders.filter((folder) => folder !== folderName)
      );
      let encryptedData = CryptoJS.AES.encrypt(
        jsonString,
        secretKey
      ).toString();
      let urlSafefold = encryptedData.replace(/\//g, "bbbb");
      setUrlSafeFold(urlSafefold);
      // setObjData(prevState => {
      //   // Create a copy of the previous state
      //   const newState = [...prevState];
      //   // Remove the item at the specified index from selectedFolders array
      //   newState[indexToRemoveMain].selectedFolders.splice(indexToRemove, 1);
      //   return newState;
      // });
      prevData[i] = {
        ...prevData[i],
        url: `${
          window.origin
        }/signin/${urlSafefold}/${urlSafePass}/${urlSafeDate}/${urlSafefold}?de=${encodeURIComponent(
          urlSafeValue
        )}&key=${encodeURIComponent(
          urlSafeKeyImages
        )}&sharing=${encodeURIComponent(urlSafeShare)}`,
        selectedFolders: prevData[i].selectedFolders.filter(
          (name) => name !== folderName
        ),
        // Create a copy of the previous state
        // const newState = [...prevState];
        // // Remove the item at the specified index from selectedFolders array
        // newState[indexToRemoveMain].selectedFolders.splice(indexToRemove, 1);
        // return newState;
      };

      // prevData[i] = {
      //   ...prevData[i],
      //   url: `${window.origin}/signin/${urlSafeEmail}/${urlSafePass}/${urlSafeDate}/${urlSafefold}`,
      //   selectedFolders: [...selectedFolder, folderName],
      // };
    }

    setTinyCopiedText(prevData[i], prevData[i]?.url, i);

    setObjData(prevData);
  };
  const removeFolder = (indexToRemoveMain, indexToRemove) => {
    setObjData((prevState) => {
      // Create a copy of the previous state
      const newState = [...prevState];
      // Remove the item at the specified index from selectedFolders array
      newState[indexToRemoveMain].selectedFolders.splice(indexToRemove, 1);
      return newState;
    });
  };
  // let urlSafeFolderName= encryptedFolderName.replace(/\//g, "bbbb");
  // let urlSafeEmail = encryptedEmail.replace(/\//g, "bbbb");
  // let urlSafePass = encryptedPass.replace(/\//g, "bbbb");
  // let urlSafeDate = encryptedDate.replace(/\//g, "bbbb");

  const [copiedText, setCopiedText] = useState([]);

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };
  const setTinyCopiedText = async (object_data, full_url, index) => {
    const isTrue = object_data?.pass && object_data?.date ? true : false;

    if (isTrue) {
      try {
        const response = await axios.get(
          `${UploadApi}/apiUpload/api-create?url=${encodeURIComponent(
            full_url
          )}`
        );

        const newCopiedText = [...copiedText];
        while (newCopiedText.length <= index) {
          newCopiedText.push("");
        }
        newCopiedText[index] = response.data || full_url;

        setCopiedText(newCopiedText);
      } catch (error) {
        const newCopiedText = [...copiedText];
        while (newCopiedText.length <= index) {
          newCopiedText.push("");
        }
        newCopiedText[index] = full_url;

        setCopiedText(newCopiedText);
      }
    } else {
      const newCopiedText = [...copiedText];
      while (newCopiedText.length <= index) {
        newCopiedText.push("");
      }
      newCopiedText[index] = full_url;

      setCopiedText(newCopiedText);
    }
  };

  const formatDateTime = (isoDateStr) => {
    try {
      const dateObj = new Date(isoDateStr);

      // Format date as YYYY-MM-DD
      const datePart = dateObj.toISOString().split("T")[0];

      // Format time as h:mm AM/PM
      const hours = dateObj.getHours();
      const minutes = dateObj.getMinutes().toString().padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";
      const formattedHour = hours % 12 || 12; // Convert 0 -> 12 for 12 AM
      const timePart = `${formattedHour}:${minutes} ${ampm}`;

      return "\t" + datePart + "\t" + timePart;
    } catch (error) {
      console.error(error);
      return "";
    }
  };

  return (
    <>
      <Dialog
        open={cOpen}
        TransitionComponent={Transition}
        onClose={() => setCOpen(false)}
        aria-describedby="alert-dialog-slide-description"
        fullScreen={fullScreen}
        className="mrc-share-modal"
        PaperProps={{
          sx: {
            width: { xs: "77%", sm: "57%" },
            height: { xs: "77%", sm: "77%" },
            maxHeight: {
              xs: "none",
              sm: "calc(100% - 64px)",
              md: "calc(100% - 64px)",
            },
            maxWidth: { xs: "100%", sm: "none", md: "600px" },
            // backgroundColor: 'rgba(0, 0, 0, 0.4)',
            // WebkitBackdropFilter: "blur(1.5px)", // Corrected key
            // backdropFilter: "blur(1.5px)",
            // overflowX: "scroll",
            //   border: '1px solid white',
            // overflowY: "hidden",
          },
        }}
      >
        {/* <DialogTitle style={{ marginLeft: 5 }}>
          {"Share Folders"}{" "}
          <Button
            onClick={AddSharePerson}
            variant="contained"
            className="float-right flex "
          >
            {" "}
            <MdAdd />
            ADD
          </Button>
           <span
            style={{
              cursor: "pointer",
            }}
            onClick={AddSharePerson}
            className="float-right flex "
          >
            <MdAdd />
            ADD
          </span> 
          <Button
            className="float-right flex "
            onClick={() => {
              setCOpen(false);
              // setshow(false);
              // setObjData([
              //   {
              //     email: "",
              //     pass: "",
              //     date: "",
              //     url: "",
              //   },
              // ]);
              // setPass("");
              // setDate("");
              // setArrayForRender([1]);
            }}
          >
            Back
          </Button>
        </DialogTitle> */}
        <DialogTitle
          sx={{
            // marginLeft: 5,
            display: "flex",
            flexDirection: { xs: "row", sm: "row" }, // Column on mobile, row on larger screens
            alignItems: "center",
            justifyContent: "space-between",
            fontSize: { xs: "small", sm: "small", md: "la" },
            gap: 1, // Adds spacing between buttons in column mode
          }}
        >
          {"Share Folders"}

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "row", sm: "row" },
              gap: 1,
            }}
          >
            <Button
              onClick={AddSharePerson}
              variant="contained"
              className="flex"
            >
              <MdAdd />
              ADD
            </Button>

            <Button
              className="flex"
              onClick={() => {
                setCOpen(false);
              }}
            >
              Back
            </Button>
          </Box>
        </DialogTitle>
        {/* {Both()} */}

        {ObjData?.map((e, i) => {
          return (
            <div className="mrc-content" style={{ marginTop: "-1rem" }}>
              <DialogContent
                // style={{ overflowX: "hidden", marginLeft: 5 }}
                sx={{
                  overflowX: "hidden",
                  marginLeft: { xs: 0, sm: 0, md: 0 },
                  padding: {
                    xs: "19px 11px",
                    sm: "20px 24px;",
                    md: "20px 24px;",
                  },
                }}
                className="mrc-share-content"
              >
                <DialogContentText id="alert-dialog-slide-description">
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    {e?.createdAt && e?.createdAt != "undefined" && (
                      <div>
                        Share URL created at:
                        {formatDateTime(e?.createdAt) || "N/A"}
                      </div>
                    )}
                    {e?.updatedAt &&
                      e?.updatedAt != "" &&
                      e?.updatedAt != "undefined" && (
                        <div>
                          Updated At:
                          {formatDateTime(e?.updatedAt) || "N/A"}
                        </div>
                      )}
                    <div
                      className="single-share"
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        width: { xs: "289px", sm: "540px", md: "540px" },
                      }}
                      // style={{
                      //   display: "flex",
                      //   flexDirection: "row",
                      //   width: "540px",
                      // }}
                    >
                      <OutlinedInput
                        margin="normal"
                        required
                        fullWidth
                        label={"link"}
                        variant="outlined"
                        value={e?.url}
                        disabled={true}
                      />
                    </div>
                    {/* <hr /> */}
                    <br />
                    <div className="relative w-[65vw] sm:w-[35vw] md:w-[35vw] lg:w-[38.5vw] xl:w-[32.5vw]">
                      <button
                        id="dropdownBgHoverButton"
                        className="d-flex font-medium rounded-lg text-sm p-2 py-2.5 mb-2 text-center cursor-pointer items-center border-2 w-full"
                        type="button"
                        onClick={() => toggleDropdown(i)}
                      >
                        <div className="flex flex-wrap">
                          {e?.selectedFolders
                            ?.slice(0, 2)
                            ?.map((folderName, index) => (
                              <div
                                key={index}
                                className="flex items-center border border-gray-300 rounded-md px-2 mr-2 mb-2"
                              >
                                <span>{folderName}</span>
                                <button
                                  className="ml-1 text-gray-500 hover:text-red-500"
                                  onClick={() => removeFolder(i, index)}
                                >
                                  <svg
                                    className="w-3 h-3"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth="2"
                                      d="M6 18L18 6M6 6l12 12"
                                    />
                                  </svg>
                                </button>
                              </div>
                            ))}
                        </div>

                        {(!e?.selectedFolders ||
                          e.selectedFolders.length === 0) && (
                          // Display "Select Folders" when no folder is selected
                          <span>Select Folders</span>
                        )}

                        <div className="flex flex-wrap">
                          {e?.selectedFolders?.length > 2 && (
                            <span>+{e?.selectedFolders?.length - 2} more</span>
                          )}
                        </div>

                        <svg
                          onClick={() => toggleDropdown(i)}
                          className="w-2.5 h-2.5 ms-3 cursor-pointer"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 10 6"
                        >
                          <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="m1 1 4 4 4-4"
                          />
                        </svg>
                      </button>
                      {ObjData[i]?.Folders && (
                        <div
                          id="dropdownBgHover"
                          className="absolute  bottom-full z-10 w-full h-24 bg-white rounded-lg shadow dark:bg-gray-700"
                        >
                          <ul
                            className="p-3 space-y-1 text-sm h-24 text-dark dark:text-gray-200 mrc-multi-ul"
                            aria-labelledby="dropdownBgHoverButton"
                          >
                            {/* {selectedFolders?.map((selectedFolder, index) => (
                              <li key={index}>
                                <div className="flex w-full items-center p-2 rounded text-dark hover:bg-gray-100 dark:hover:bg-gray-600">
                                  <span>{selectedFolder}</span>
                                </div>
                              </li>
                            ))} */}
                            {folderlist?.map(
                              (item, index) =>
                                item != "archive" &&
                                item != "Multi" && (
                                  <li key={index}>
                                    <div className="flex w-full items-center p-1 group rounded text-dark hover:bg-gray-100 dark:hover:bg-gray-600">
                                      <input
                                        id={`checkbox-item-${index}`}
                                        type="checkbox"
                                        value={item}
                                        className="w-4 h-4 text-blue-600 bg-gray-100 text-dark border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                                        onChange={(event) =>
                                          handleCheckboxChange(event, i)
                                        }
                                        defaultChecked={e?.selectedFolders?.includes(
                                          item
                                        )} // Check if the folder is in selectedFolders
                                      />
                                      <label
                                        htmlFor={`checkbox-item-${index}`}
                                        className="w-full ms-2 text-sm font-medium rounded mb-0 text-gray-800 group-hover:text-gray-300"
                                      >
                                        {item}
                                      </label>
                                    </div>
                                  </li>
                                )
                            )}
                          </ul>
                        </div>
                      )}
                      <br />
                    </div>
                    <Grid
                      container
                      spacing={2}
                      sx={{
                        marginTop: "-59px",
                        flexDirection: {
                          xs: "column",
                          sm: "column",
                          md: "row",
                        },
                      }}
                    >
                      {/* <Grid item xs={4}>
                        <br />
                        <TextField
                          hiddenLabel
                          label="User Name"
                          variant="outlined"
                          size="small"
                          // disabled={true}
                          type={"email"}
                          value={e.email}
                          onChange={(event) => {
                            // setEmail(e.target.value);
                            onChangeField(event, i);
                          }}
                          name="email"
                          // onChange={(e) => {setEmail(e.target.value);onChangeField(e)}}
                          style={{
                            borderRadius: "3px",
                            backgroundColor: "white",
                            width: 190,
                          }}
                        />
                      </Grid> */}
                      <Grid item xs={6} style={{ paddingLeft: 18 }}>
                        <br />
                        <TextField
                          autocomplete="new-password"
                          autoFocus
                          hiddenLabel
                          label="password"
                          variant="outlined"
                          size="small"
                          type={showPassword ? "text" : "password"}
                          // value={pass}
                          name="pass"
                          value={e.pass}
                          onChange={(event) => {
                            setDate(event.target.value);
                            onChangeField(event, i);
                          }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  onClick={handleTogglePassword}
                                  edge="end"
                                >
                                  {showPassword ? (
                                    <VisibilityOff />
                                  ) : (
                                    <Visibility />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          style={{
                            borderRadius: "3px",
                            backgroundColor: "white",
                            width: 268,
                            // width:
                            // window.innerWidth < 600
                            //   ? "17rem" // Mobile
                            //   : window.innerWidth < 960
                            //   ? "33.5rem" // Tablet
                            //   : "268px",
                          }}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        sx={{
                          paddingLeft: { xs: "10px", sm: 16, md: 16 },
                          paddingTop: { xs: "10px", sm: 16, md: 16 },
                        }}
                      >
                        <br />
                        <TextField
                          label="Expire Date"
                          InputLabelProps={{ shrink: true, required: true }}
                          variant="outlined"
                          size="small"
                          // value={date}
                          onChange={(event) => {
                            // setEmail(e.target.value);
                            onChangeField(event, i);
                          }}
                          type="date"
                          value={e.date}
                          min={
                            new Date().toISOString().substr(0, 19).split("T")[0]
                          }
                          style={{ borderRadius: "3px", width: 270 }}
                          name="date"
                        />
                      </Grid>
                    </Grid>
                  </div>
                </DialogContentText>
              </DialogContent>
              <div className="flex w-full items-center pl-4 p-1 group rounded text-dark">
                <input
                  id={`checkbox-item-${i}`}
                  type="checkbox"
                  name="canUpload"
                  checked={e?.canUpload == "yestofileupload"}
                  value={e?.canUpload == "yestofileupload"}
                  className="w-4 h-4 text-blue-600 bg-gray-100 text-dark border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                  onChange={(event) => {
                    onChangeField(event, i);
                  }}
                  disabled={e?.isKeyImagesOnly == "onlykeyimages"}
                  defaultChecked={e?.canUpload == "yestofileupload"} // Check if the folder is in selectedFolders
                />
                <label
                  htmlFor={`checkbox-item-${i}`}
                  className="w-full ms-2 text-sm font-medium rounded mb-0 text-gray-800 "
                >
                  Allow file upload
                </label>
                <input
                  id={`checkbox-keyimages-${i}`}
                  type="checkbox"
                  name="onlyKeyImages"
                  checked={e?.isKeyImagesOnly == "onlykeyimages"}
                  value={e?.isKeyImagesOnly == "onlykeyimages"}
                  className="w-4 h-4 text-blue-600 bg-gray-100 text-dark border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                  onChange={(event) => {
                    onChangeField(event, i);
                  }}
                  defaultChecked={e?.isKeyImagesOnly == "onlykeyimages"} // Check if the folder is in selectedFolders
                />
                <label
                  htmlFor={`checkbox-keyimages-${i}`}
                  className="w-full ms-2 text-sm font-medium rounded mb-0 text-gray-800 "
                >
                  Only Key Images
                </label>
                <input
                  id={`checkbox-sharing-${i}`}
                  type="checkbox"
                  name="canShare"
                  checked={e?.canShare == "yesshare"}
                  value={e?.canShare == "yesshare"}
                  className="w-4 h-4 text-blue-600 bg-gray-100 text-dark border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                  onChange={(event) => {
                    onChangeField(event, i);
                  }}
                  defaultChecked={e?.canShare == "yesshare"} // Check if the folder is in selectedFolders
                />
                <label
                  htmlFor={`checkbox-sharing-${i}`}
                  className="w-full ms-2 text-sm font-medium rounded mb-0 text-gray-800 "
                >
                  Allow File Sharing
                </label>
              </div>
              <DialogActions
                sx={{
                  marginBottom: "10px",
                  justifyContent: "center",
                  display: "flex",
                  flexWrap: "wrap", // Allow buttons to wrap on small screens
                  gap: 1, // Adds spacing between buttons
                  "& > *": {
                    flex: { xs: "1 1 calc(50% - 8px)", md: "unset" }, // 2 per row on mobile/tablet, all in 1 row on large screens
                  },
                }}
              >
                {/* Email button */}
                {/* <Button
                  variant="contained"
                  sx={{
                    fontSize: { xs: "xx-small", sm: "small", md: "small" },
                  }}
                  disabled={
                    e?.pass && e?.date && e?.selectedFolders?.length > 0
                      ? false
                      : true
                  }
                  onClick={() => {
                    setModal(true);
                    // ShareFolderLink(e);
                    setselected(e);
                    setSelectedIndex(i);
                    // onClick={() =>
                    // SendEmail();
                  }}
                >
                  Send via email
                </Button> */}
                {/* Back button  */}
                {/* <Button
                  className="float-right flex "
                  onClick={() => {
                    setCOpen(false);
                    setshow(false);
                    setObjData([
                      {
                        email: "",
                        pass: "",
                        date: "",
                        url: "",
                      },
                    ]);
                    setPass("");
                    setDate("");
                    // setArrayForRender([1]);
                  }}
                >
                  Back
                </Button> */}
                <Button
                  sx={{
                    fontSize: { xs: "xx-small", sm: "small", md: "small" },
                  }}
                  onClick={() => {
                    RemoveSharePerson(e, i);
                  }}
                >
                  Remove
                </Button>

                {/* QR button */}
                <Button
                  sx={{
                    fontSize: { xs: "xx-small", sm: "small", md: "small" },
                  }}
                  disabled={
                    e?.pass && e?.date && e?.selectedFolders?.length > 0
                      ? false
                      : true
                  }
                  onClick={() => {
                    setshow(!show);

                    ShareFolderLink(e, i);
                  }}
                >
                  Share QR Code
                </Button>
                {/* QR code  */}
                {show && (
                  <QRCode
                    size={256}
                    bgColor="#000000"
                    fgColor="#ffffff"
                    style={{
                      height: "auto",
                      maxWidth: "100%",
                      width: "15%",
                    }}
                    value={copiedText[i]}
                    viewBox={`256 256 256 256`}
                  />
                )}

                {/* copy to clipboard */}
                <CopyToClipboard
                  text={`${copiedText[i]}`}
                  // email: ${e?.email}
                  // password: ${e?.pass}
                  // onClick={()=> {ShareFolderLink(e);}}
                >
                  <Button
                    sx={{
                      fontSize: { xs: "xx-small", sm: "small", md: "small" },
                    }}
                    variant="contained"
                    onClick={() => {
                      // ShareFolderLink(e);
                      setIsOpen(true);
                      ShareData();
                      setTimeout(() => {
                        setIsOpen(false);
                      }, 2000);
                      ShareFolderLink(e, i);
                      saveCredentials({
                        accession: cAccession,
                        link: `${e?.url}/`,
                        CaseID: e?.email,
                        pass: e?.pass,
                      });
                    }}
                    disabled={
                      e?.pass && e?.date && e?.selectedFolders?.length > 0
                        ? false
                        : true
                    }
                  >
                    Copy to clipboard
                  </Button>
                </CopyToClipboard>
              </DialogActions>
              <hr />
              {/* style={{  border: 'none', height:'1px',backgroundColor:'black',fontWeight:'bold'}}/> */}
            </div>
          );
        })}

        {/* {ArrayForRender.map((key, value) => Both(value))} */}
        <CustomizedSnackbars
          isOpen={isOpen}
          severity={"success"}
          message={"Credentials copied to clipboard"}
        />
      </Dialog>

      <Dialog
        open={modal}
        // TransitionComponent={Transition}
        TransitionComponent={Transition}
        style={{ height: "100%" }}
        PaperProps={{
          style: {
            height: "70%",
            //   border: '1px solid white',
          },
        }}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent
          style={{ overflowX: "hidden", marginLeft: 5 }}
          className="mrc-share-content"
        >
          <DialogContentText id="alert-dialog-slide-description">
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "540px",
                }}
              >
                <OutlinedInput
                  margin="normal"
                  required
                  fullWidth
                  label={"link"}
                  variant="outlined"
                  // value={`${window.origin}/signin/${urlSafeEmail}/${urlSafePass}/${urlSafeDate}`}
                  value={`${selected?.url}`}
                  disabled={true}
                />
              </div>
              <hr />

              <Grid container spacing={2} style={{ marginTop: "-35px" }}>
                {/* <Grid item xs={4} >         
                <br/>
                    <TextField hiddenLabel label='Case ID'  variant='outlined' disabled={true} size="small" type={"email"} value={email}  style={{ borderRadius: "3px" , backgroundColor:'white',width:190}} />
                </Grid> */}
                <Grid item lg={12} style={{ paddingLeft: 23 }}>
                  <br />
                  <TextField
                    autoFocus
                    hiddenLabel
                    label="Email"
                    variant="outlined"
                    size="small"
                    type={"email"}
                    value={emailToSend}
                    onChange={(e) => setEmailToSend(e.target.value)}
                    style={{
                      borderRadius: "3px",
                      backgroundColor: "white",
                      width: 500,
                    }}
                  />
                </Grid>
                <Grid item lg={12} style={{ paddingLeft: 23 }}>
                  <br />
                  <TextField
                    autoFocus
                    hiddenLabel
                    label="Subject"
                    variant="outlined"
                    size="small"
                    type={"text"}
                    value={"Sharing Study"}
                    style={{
                      borderRadius: "3px",
                      backgroundColor: "white",
                      width: 500,
                    }}
                  />
                </Grid>
              </Grid>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ marginRight: "22px", marginBottom: "10px" }}>
          {/* <Button variant="contained" disabled={email && pass && date ? false : true} onClick={()=>setModal(true)} >Share with email</Button> */}
          <Button
            onClick={() => {
              setModal(false);
              setObjData([
                {
                  email: "",
                  pass: "",
                  date: "",
                  url: "",
                },
              ]);
            }}
          >
            Back
          </Button>
          <Button variant="contained" onClick={() => SendEmail()}>
            Send Email
          </Button>
        </DialogActions>
      </Dialog>
      <hr />
    </>
  );
}
